import { ApplicationConfig, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { registerLocaleData } from '@angular/common';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideNativeDateAdapter } from '@angular/material/core';
import ptBr from '@angular/common/locales/pt';

import { provideEnvironmentNgxMask } from 'ngx-mask';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

import { AuthService } from './core/services/auth.service';
import { cookieInterceptor } from './core/interceptors/cookie.interceptor';
import { requestErrorInterceptor } from './core/interceptors/request-error.interceptor';
import { responseBodyInterceptor } from './core/interceptors/response-body.interceptor';

import { routes } from './app.routes';

registerLocaleData(ptBr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([
        cookieInterceptor,
        requestErrorInterceptor,
        responseBodyInterceptor,
      ])
    ),
    provideNativeDateAdapter(),
    provideEnvironmentNgxMask(),
    { provide: LOCALE_ID, useValue: 'pt' },
    provideAnimationsAsync(),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthService) => () =>
        firstValueFrom(authService.secureLogin()),
      deps: [AuthService],
      multi: true,
    },
  ],
};
